import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChangeLanguage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37259 22.6274 4 16 4C9.37259 4 4 9.37259 4 16C4 22.6274 9.37259 28 16 28Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 15.9999H28",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6153 16C20.3886 20.3883 18.7723 24.5908 15.9999 28C13.2276 24.5908 11.6112 20.3883 11.3845 16C11.6112 11.6117 13.2276 7.40921 15.9999 4C18.7723 7.40921 20.3886 11.6117 20.6153 16V16Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgChangeLanguage);
export default ForwardRef;
